export const getSubscriptionDisplayName = (
  subscriptionName?: string,
): string | undefined => {
  switch (subscriptionName) {
    case 'SampleSafetyPlus':
      return 'Sample Safety+';
    default:
      return subscriptionName;
  }
};

export const getSubscriptionTypeDisplayName = (
  subscriptionTypeName?: string,
): string | undefined => {
  switch (subscriptionTypeName) {
    case 'Academia':
      return 'Academic';
    default:
      return subscriptionTypeName;
  }
};
